// Extracted from https://spannerisms.github.io/alldamage/ - Thanks kan!
export const spriteIds: { [key: number]: string } = {
  0x00: "Raven",
  0x01: "Vulture",
  0x02: "Stalfos head",
  0x03: "Undefined",
  0x04: "Pull switch",
  0x05: "Switch(unused)",
  0x06: "Pull switch(wrong)",
  0x07: "Switch(unused)",
  0x08: "Octorok",
  0x09: "Moldorm",
  0x0A: "Octorok (4-way)",
  0x0B: "Cucco",
  0x0C: "Octorok stone",
  0x0D: "Buzzblob",
  0x0E: "Snapdragon",
  0x0F: "Octoballoon",
  0x10: "Octoballoon baby",
  0x11: "Hinox",
  0x12: "Moblin",
  0x13: "Mini helmasaur",
  0x14: "Thieves' Town grate",
  0x15: "Antifairy",
  0x16: "SahasrahlaAginah",
  0x17: "Hoarder",
  0x18: "Mini moldorm",
  0x19: "Poe",
  0x1A: "Smithy",
  0x1B: "Arrow",
  0x1C: "Statue",
  0x1D: "Weathervane",
  0x1E: "Crystal switch",
  0x1F: "Sick kid",
  0x20: "Sluggula",
  0x21: "Water drain switch",
  0x22: "Ropa",
  0x23: "Red bariRed biri",
  0x24: "Blue bari",
  0x25: "Talking tree",
  0x26: "Hard hat beetle",
  0x27: "Deadrock",
  0x28: "Dark World hint NPC",
  0x29: "Miscellaneous adults",
  0x2A: "Sweeping lady",
  0x2B: "Hobo",
  0x2C: "Lumberjacks",
  0x2D: "Neckless man(unused)",
  0x2E: "StumpyFlute ghost",
  0x2F: "Race game lady",
  0x30: "Race game guy",
  0x31: "Fortune teller",
  0x32: "Argue Bros",
  0x33: "Rupee pull",
  0x34: "Young snitch",
  0x35: "Innkeeper",
  0x36: "Witch",
  0x37: "Waterfall",
  0x38: "Palace of Darknesseye statue",
  0x39: "Middle-aged thief",
  0x3A: "Magic bat",
  0x3B: "Bonk item",
  0x3C: "Kid in Kak",
  0x3D: "Old snitch",
  0x3E: "Hoarder",
  0x3F: "Tutorial guard",
  0x40: "Lightning barrier",
  0x41: "Blue guard",
  0x42: "Green guard",
  0x43: "Red spear guard",
  0x44: "Bluesain Bolt",
  0x45: "Usain Bolt",
  0x46: "Blue archer",
  0x47: "Green bush guard",
  0x48: "Red javelin guard",
  0x49: "Red bush guard",
  0x4A: "Bomb guard",
  0x4B: "Green knife guard",
  0x4C: "Geldman",
  0x4D: "Toppo",
  0x4E: "Popo",
  0x4F: "Popo",
  0x50: "Cannonball",
  0x51: "Armos statue",
  0x52: "King Zora",
  0x53: "Armos Knight",
  0x54: "Lanmola",
  0x55: "Zora/Fireball",
  0x56: "Zora",
  0x57: "Desert Palace statues",
  0x58: "Crab",
  0x59: "Bird(Lost Woods)",
  0x5A: "Squirrel(Lost Woods)",
  0x5B: "Spark",
  0x5C: "Spark",
  0x5D: "Roller(vertical, down)",
  0x5E: "Roller(vertical, up)",
  0x5F: "Roller(horizontal, right)",
  0x60: "Roller(horizontal, left)",
  0x61: "Beamos",
  0x62: "Mastersword",
  0x63: "Sandpit",
  0x64: "Debirando",
  0x65: "Archery guy",
  0x66: "Wall cannon(vertical, left)",
  0x67: "Wall cannon(vertical, right)",
  0x68: "Wall cannon(horizonal, top)",
  0x69: "Wall cannon(horizonal, bottom)",
  0x6A: "Ball 'n' Chain",
  0x6B: "Cannonball/Cannon trooper",
  0x6C: "Mirror portal",
  0x6D: "RatCricket",
  0x6E: "Snake",
  0x6F: "Keese",
  0x70: "King Helmasaurfireball",
  0x71: "Leever",
  0x72: "Faerie pond trigger",
  0x73: "UnclePriest/Mantle",
  0x74: "Running man",
  0x75: "Bottle vendor",
  0x76: "Zelda",
  0x77: "Antifairy",
  0x78: "Sahsrahla's wife",
  0x79: "Bee",
  0x7A: "Agahnim",
  0x7B: "Agahnim's balls",
  0x7C: "Green stalfos",
  0x7D: "Big spike",
  0x7E: "Firebar(clockwise)",
  0x7F: "Firebar(counterclockwise)",
  0x80: "Firesnake",
  0x81: "Hover",
  0x82: "Antifairy (circle)",
  0x83: "Green eyegoreGreen mimic",
  0x84: "Red eyegoreRed mimic",
  0x85: "Yellow stalfos",
  0x86: "Kodongo",
  0x87: "Kondongo fire",
  0x88: "Mothula",
  0x89: "Mothula beam",
  0x8A: "Spike block",
  0x8B: "Gibdo",
  0x8C: "Arrghus",
  0x8D: "Arrghus puff",
  0x8E: "Terrorpin",
  0x8F: "Blob",
  0x90: "Wallmaster",
  0x91: "Stalfos knight",
  0x92: "King Helmasaur",
  0x93: "Bumper",
  0x94: "Pirogusu",
  0x95: "Eye laser(left)",
  0x96: "Eye laser(right)",
  0x97: "Eye laser(top)",
  0x98: "Eye laser(bottom)",
  0x99: "Pengator",
  0x9A: "Kyameron",
  0x9B: "Wizzrobe",
  0x9C: "Zoro",
  0x9D: "Babasu",
  0x9E: "Ostritch(Haunted Grove)",
  0x9F: "Rabbit(Haunted Grove)",
  0xA0: "Bird(Haunted Grove)",
  0xA1: "Freezor",
  0xA2: "Kholdstare",
  0xA3: "Kholdstare shell",
  0xA4: "Falling ice",
  0xA5: "Blue zazak",
  0xA6: "Red zazak",
  0xA7: "Stalfos",
  0xA8: "Green zirro",
  0xA9: "Blue zirro",
  0xAA: "Pikit",
  0xAB: "Crystal Maiden",
  0xAC: "Apple",
  0xAD: "Old man",
  0xAE: "Pipe (down)",
  0xAF: "Pipe (up)",
  0xB0: "Pipe (right)",
  0xB1: "Pipe (left)",
  0xB2: "Golden bee/Friendly bee",
  0xB3: "Pedestal plaque",
  0xB4: "Purple chest",
  0xB5: "Bombshop guy",
  0xB6: "Kiki",
  0xB7: "Blind(maiden)",
  0xB8: "Dialogue tester",
  0xB9: "BullyPink ball",
  0xBA: "Whirlpool",
  0xBB: "ShopkeeperChest game guy",
  0xBC: "Drunkard",
  0xBD: "Vitreous",
  0xBE: "Vitreous small eye",
  0xBF: "Lightning",
  0xC0: "Catfish",
  0xC1: "Agahnim(cutscene)",
  0xC2: "Boulder",
  0xC3: "Gibo",
  0xC4: "Thief",
  0xC5: "Medusa",
  0xC6: "4-way shooter",
  0xC7: "Pokey",
  0xC8: "Big faerie",
  0xC9: "Tektite/Firebat",
  0xCA: "Chain chomp",
  0xCB: "Trinexx(rock head)",
  0xCC: "Trinexx(fire head)",
  0xCD: "Trinexx(ice head)",
  0xCE: "Blind",
  0xCF: "Swamola",
  0xD0: "Lynel",
  0xD1: "Bunnybeam/Chimney smoke",
  0xD2: "Flopping fish",
  0xD3: "Stal",
  0xD4: "Landmine",
  0xD5: "Dig game guy",
  0xD6: "Ganon",
  0xD7: "Ganon",
  0xD8: "Heart",
  0xD9: "Green rupee",
  0xDA: "Blue rupee",
  0xDB: "Red rupee",
  0xDC: "Bomb refill (1)",
  0xDD: "Bomb refill (4)",
  0xDE: "Bomb refill (8)",
  0xDF: "Small magic decanter",
  0xE0: "Large magic decanter",
  0xE1: "Arrow refill (5)",
  0xE2: "Arrow refill (10)",
  0xE3: "Faerie",
  0xE4: "Small key",
  0xE5: "Big key",
  0xE6: "Stolen shield",
  0xE7: "Mushroom",
  0xE8: "Fake Master Sword",
  0xE9: "Magic shop assistant",
  0xEA: "Heart container",
  0xEB: "Heart piece",
  0xEC: "Thrown item",
  0xED: "Somaria platform",
  0xEE: "Castle throne",
  0xEF: "Somaria platform(unused)",
  0xF0: "Somaria platform(unused)",
  0xF1: "Somaria platform(unused)",
  0xF2: "Medallion tablet",
  0xF3: "Undefined",
  0xF4: "Undefined",
  0xF5: "Undefined",
  0xF6: "Undefined",
  0xF7: "Undefined",
  0xF8: "Undefined",
  0xF9: "Undefined",
  0xFA: "Undefined",
  0xFB: "Undefined",
  0xFC: "Undefined",
  0xFD: "Undefined",
  0xFE: "Undefined",
  0xFF: "Undefined",
}
